import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} NOVIONIX Labs. All rights reserved.
    </footer>
  );
}
